import { IconBrandGithub, IconBrandLeetcode, IconBrandLinkedin, IconBrandX, } from "@tabler/icons-react";


const Info= {
    name: "Arnold Uwamwezi",
    stack: ["Software Engineer", "Web Developer", " Freelancer", "Competitive Programmer"],
    bio:"I'm a passionate software engineer with a strong background in programming and web development. I specialise in creating efficient and scalable solutions, deliver top-notch web applications and provide freelance services that exceed client expectations. Let’s connect and create amazing things together! "
}


const ProjectInfo = [
    {
        title: "FMS Africa Admin Platform",
        desc: "A centralized administrative dashboard designed for comprehensive fleet management oversight and system configuration. The admin platform serves as the core control center for FMS Africa's fleet monitoring ecosystem, enabling administrators to manage multi-tenant operations, configure system-wide settings, and oversee the entire network of resellers and end clients. Key features include user access management, RFID driver tag configuration, GPS tracking device administration, real-time alert configuration (tamper alerts, maintenance due notifications, document expiration), and comprehensive MIS reporting for operational cost optimization. The system leverages telematics and IoT technologies to deliver real-time monitoring, analysis, and control capabilities that enable asset optimization and significant operational expense reductions for businesses across Africa.",
        image: "fms-admin.png",
        live: true,
        technologies: ["React", "IoT Integration", "GPS Tracking", "Real-time Analytics", "Multi-tenant Architecture", "Telematics", "RFID Technology", "MIS Reporting"],
        github: "",
        link: "https://admin.fms-ecsafrica.com/",
    },
    {
        title: "FMS Africa Reseller Platform",
        desc: "A comprehensive fleet management solution providing resellers and end-clients with real-time insights, route optimization, and cost reduction capabilities. The platform delivers smart fleet management tools featuring GPS-based vehicle tracking, fuel consumption monitoring, predictive maintenance scheduling, and driver performance analytics. Users gain instant visibility into vehicle locations, usage patterns, and operational metrics through an intuitive dashboard interface. Core functionalities include real-time fleet location tracking, historical route analysis, driver behavior insights (overspeeding, harsh braking, idle time), fuel theft prevention, cold chain monitoring with temperature sensors, and delivery performance optimization. The system empowers fleet managers to make data-driven decisions that enhance productivity, reduce operational costs, and improve customer service through accurate delivery tracking.",
        image: "fms-reseller.png",
        live: true,
        technologies: ["React", "GPS Tracking", "IoT Sensors", "Real-time Monitoring", "Predictive Analytics", "Route Optimization", "Cold Chain Monitoring", "Fuel Management"],
        github: "",
        link: "https://app.fms-ecsafrica.com/",
    },
    {
        title: "RIMS | Refactory Information Management System",
        desc: "This project is built for the Refactory it is going to automate the various in-house processes as well as the use of several external tools. The process of all these functionalities occurring in a single internal system. This portal is main for frontend functionalities and is built on the React.js Library",
        image: "refactory-image.png",
        live: true,
        technologies: ["React and React Ecosystem", "Material UI (MUI)", "Vite", "Bootstrap and Ant Design (AntD)", "Cypress" , "Jest", "NestJS Framework", "Prisma", "Validation and Transformation", "Authentication and Authorization", "Testing Frameworks like jest",  "TypeScript and Linting" , "UUID and Utilities", "Email Templating:"],
        github: "https://github.com/Refactory-Uganda",
        link: "https://rims-portal-3jdy.onrender.com/",
    },
    {
        title: "medipoint",
        desc: "MediPoint leverages React's component-based architecture and Tailwind's utility-first approach to create a fast, efficient, and visually appealing platform. The app's responsive design ensures a consistent experience across desktop, tablet, and mobile devices, making healthcare access more convenient than ever..",
        image: "medipoint.png",
        live: true,
        technologies: ["React", "Tailwindp", "Mongo Atlas"],
        github: "https://github.com/arnoldcod/medipoint",
        link: "https://medipoint.onrender.com/",
    },
    {
        title: "Food Delivery App ",
        desc: "Tomato is a modern food delivery app built using the MERN stack (MongoDB, Express.js, React, Node.js) that offers a seamless and enjoyable online food shopping experience. With Tomato, users can effortlessly browse and search for their favorite food items, adding them to a orderlist for later or directly to a shopping cart for immediate purchase. The checkout process is designed with user security and convenience in mind, featuring robust form validation to ensure the accuracy of address and payment details. After completing a purchase, users can easily access their order history in the Orders section. Tomato makes online food shopping both effortless and enjoyable.",
        image: "Tomato.png",
        live: true,
        technologies: ["React", "Express", "MongoDB", "Tailwind", "Stripe", "Nodejs"],
        github: "https://github.com/arnoldcod/Food-app",
        link: "https://food-delivery-front-end-mh4b.onrender.com"
        
    },
    {
        title: "Daystar App",
        desc: "Daystar is a modern, fully responsive web platform built using Vue and Pug, Bootstrap, and Nodejs offering a seamless experience across the web. It features secure user authentication with login, registration, logout functionalities and has a doll stall for procurement management. The admin can add items to the doll stall cart for purchase or remove them. Daystar combines robust functionality with a sleek, intuitive design, making data management effortless and enjoyable.",
        image: "Daystar.png",
        live: true,
        technologies: ["Pug", "Bootstrap", "Nodejs", "Expressjs"],
        github: "https://github.com/arnoldcod/daystar-daycare",
        link: "https://daystar-xosf.onrender.com/"
    },
    {
        title: "Spotify Music",
        desc: "Spotify Clone is a full-stack web application that replicates the core features of spotify, including  music playback, and playlist creation. The front end is built with React, TailwindCSS, Heroicons, and cloudinary, while the back end usesmongodb for data storage. Users can add albums, songs, and create playlists. The app features real-time updates, so users can see new songs as they are added. Spotify Clone provides a seamless user experience with a clean, modern design and intuitive functionality.then click on live button below;",
        image: "Spotify.png",
        live: false,
        technologies: ["React", "Cloudinary", "Tailwind", "Tabler-Icons", "MongoDB"],
        github: "https://github.com/arnoldcod/Spotify-Music",
        link: "https://spotify-frontend-pdqy.onrender.com/" ,
    },
    {
        title: "APOD App",
        desc: "NASA APOD(Astronomy Picture Of the Day) App is a cutting-edge web application built with React and Tailwind CSS that brings the wonders of space exploration to your fingertips. Designed with a focus on both performance and aesthetics, this app offers users an immersive experience as they explore data and images directly from NASA’s vast repository. Whether you're browsing through stunning images of distant galaxies, accessing detailed information about planets, or staying updated with the latest space missions, the NASA App provides an intuitive and responsive interface. Tailwind CSS ensures a sleek and modern design, making space exploration not just informative but visually engaging",
        image: "Nasa.png",
        live: true,
        technologies: ["React", "Node.js", "PostgresSQL", "Express", "Bootstrap"],
        github: "https://github.com/arnoldcod",
        link: "https://nasa-app1.netlify.app/"
    },
]


const SkillInfo = [
    {
        title: "Frontend",
        skills: ["HTML", "CSS", "SASS", "JavaScript", "React JS", "Angular", "Redux", "Tailwind CSS", "GSAP", "Material UI", "Bootstrap"
        ]
    },
    {
        title: "Backend",
        skills: [ "Node JS", "Express JS", "MySQL", "MongoDB",  "PostgresSQL"]
    },
    {
        title: "Languages",
        skills: [ "Java", "JavaScript", "TypeScript", "Python"]
    },
    {
        title: "Tools",
        skills: ["Git", "Github", "VS Code", "Postman", "MongoDB Compass", "Pycharm", "Bash Script"]
    }
]
const socialLinks = [
    { link: "https://github.com/arnoldcod", icon: IconBrandGithub },
    { link: "https://www.linkedin.com/in/arnold-uwamwezi-98902b198/", icon: IconBrandLinkedin },
    { link: "https://x.com/arnoldcod_", icon: IconBrandX }, 
    { link: "https://leetcode.com/u/arnoldcod/", icon: IconBrandLeetcode }
];





const ExperienceInfo = [
    {
        role: "Project Manager & Consultant Developer",
        company: "FMS Africa Ltd",
        companyLink: "https://fms-ecsafrica.com/",
        date: "May 2025 - Present",
        desc: "Leading cross-functional development projects while providing strategic technical consulting to drive digital transformation initiatives across the organization. Currently spearheading the fmsiot-project, a comprehensive IoT fleet management system, where I manage the complete project lifecycle from requirements gathering and system architecture design through development, testing, and deployment phases. Implementing agile methodologies including sprint planning, daily standups, and retrospectives to maintain team velocity and ensure iterative delivery of high-quality features. Collaborating closely with stakeholders to define project scope, prioritize feature backlogs, and allocate resources effectively, resulting in on-time delivery of solutions that align with business objectives. Facilitating cross-team communication between developers, designers, QA engineers, and business analysts to resolve blockers and maintain project momentum. Conducting risk assessments and developing mitigation strategies to ensure project success while mentoring junior team members on best practices in software development and project management.",
        skills: ["Project Management", "Software Development", "Agile/Scrum", "Technical Consulting", "Stakeholder Management", "Requirements Analysis", "Team Leadership", "Solution Architecture"]
    },
    {
        role: "Software Engineer Apprentice",
        company: "refactory",
        companyLink: "https://refactory.academy/",
        date: "May 2024 - January 2025",
        desc: "I led software development with  React, and vue, creating scalable microservices and interfaces. I optimized performance by integrating frontend and backend, and enhanced security with RESTful APIs. Collaborating in agile teams, I fostered innovation and efficiency for top-quality solutions.",
        skills: [ "React JS", "Vue JS", "Node JS", "MySQL", "MongoDB", "Microservices"]
    },
    {
        role: "Product manager",
        company: "Treasure world",
        date: "June 2021 - Sep 2023",
        desc: " I oversaw the integration of IT systems that support inventory management and marketing efforts, ensuring seamless data flow between systems.I ensured the IT infrastructure supports the company's operations efficiently, including website management, online sales platforms, and data security. I developed and executed digital marketing strategies that leverage GIS certification and quality as key selling points. Utilize social media: TikTok, Douyin, Taobao, and other Chinese social media apps",
        skills: ["strategic thinking", "Analytical and problem solving", "communication and collaboration", "ux/ui", "customer focus"]
    }
]
const Slugs = [
    "typescript",
    "javascript",
    "java",
    "react",
    "vue",
    "flutter",
    "android",
    "html5",
    "css3",
    "human centered design",
    "mongodb",
    "selenium",
    "nodedotjs",
    "express",
    "nextdotjs",
    "prisma",
    "mysql",
    "amazonaws",
    "postgresql",
    "firebase",
    "nginx",
    "vercel",
    "testinglibrary",
    "jest",
    "cloud computing principles",
    "docker",
    "git",
    "ci/cd",
    "github",
    "gitlab",
    "visualstudiocode",
    "androidstudio",
    "figma",
    "test driven development",
    "behavior driven development"
];
export { Info, ProjectInfo,socialLinks, SkillInfo, ExperienceInfo, Slugs };